/**
 * Утилиты для определения куда перенаправлять пользователя после авторизации
 */

import { getMyGames } from '../api';

/**
 * Определяет, нужно ли перенаправить пользователя сразу в игру
 * Возвращает true если это новый пользователь (нет ни одной игры)
 * Возвращает false если у пользователя есть игры (возвращающийся пользователь)
 */
export async function shouldRedirectToGame(): Promise<boolean> {
  try {
    // Получаем минимальный ответ - только для проверки количества игр
    const response = await getMyGames(1, 1); // page=1, limit=1

    // Если у пользователя нет ни одной игры - это новый пользователь
    const isNewUser = response.pagination.total_count === 0;

    console.log('🔍 Auth redirect check:', {
      total_games: response.pagination.total_count,
      isNewUser,
      redirect: isNewUser ? '/magic (new user)' : '/my-games (returning user)'
    });

    return isNewUser;
  } catch (error) {
    console.error('Failed to check game count for redirect:', error);
    // При ошибке - безопасный fallback на my-games
    return false;
  }
}
